import { Outlet } from 'react-router-dom';
import { BarChart3, Landmark, Search, Target } from 'lucide-react';
import './AuthLayout.css';

const highlights = [
  { icon: Target, label: 'AI-Powered Lead Generation' },
  { icon: Landmark, label: 'Board Governance Tools' },
  { icon: Search, label: 'Smart Tender Discovery' },
  { icon: BarChart3, label: 'MEAL & Social Impact' },
];

export default function AuthLayout() {
  return (
    <div className="min-h-screen flex bg-lum-dark-bg">
      {/* Brand panel - dark navy background */}
      <div className="auth-brand-panel hidden lg:flex lg:w-1/2 bg-navy-dark flex-col justify-between p-12 relative overflow-hidden">
        <div className="auth-source-map" aria-hidden="true">
          <span className="auth-source-node auth-source-node-1" />
          <span className="auth-source-node auth-source-node-2" />
          <span className="auth-source-node auth-source-node-3" />
          <span className="auth-source-node auth-source-node-4" />
          <span className="auth-source-node auth-source-node-5" />
          <span className="auth-source-node auth-source-node-6" />
          <span className="auth-source-line auth-source-line-1" />
          <span className="auth-source-line auth-source-line-2" />
          <span className="auth-source-line auth-source-line-3" />
          <span className="auth-source-line auth-source-line-4" />
          <span className="auth-source-line auth-source-line-5" />
        </div>

        {/* Logo */}
        <div className="relative z-10">
          <img src="/lumora-logo-refined.svg"
            alt="Lumora" className="h-12 w-auto" />
        </div>

        {/* Hero content */}
        <div className="relative z-10">
          <h1
            className="auth-typewriter font-heading text-display-lg text-white leading-tight mb-6"
            aria-label="Work smarter. Find faster. Deliver deeper."
          >
            <span className="auth-typewriter-line auth-typewriter-line-1">Work smarter.</span>
            <span className="auth-typewriter-line auth-typewriter-line-2">Find faster.</span>
            <span className="auth-typewriter-line auth-typewriter-line-3 text-gold">Deliver deeper.</span>
          </h1>
          <p className="text-white/70 text-lg font-body leading-relaxed mb-12">
            Your AI-powered platform for lead generation, governance excellence,
            and social impact - purpose-built for Lumorus.
          </p>

          <div className="grid grid-cols-2 gap-4">
            {highlights.map((item) => (
              <div key={item.label} className="auth-highlight-card flex items-center gap-3 rounded-lum p-3">
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#2dbb72]/18 text-[#2dbb72] ring-1 ring-[#2dbb72]/30">
                  <item.icon size={17} strokeWidth={2} />
                </span>
                <span className="text-white/85 text-sm font-medium">{item.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="relative z-10 text-white/40 text-sm font-body">
          &copy; {new Date().getFullYear()} Lumorus. All rights reserved.
        </div>
      </div>

      {/* Auth form panel */}
      <div className="flex-1 flex flex-col items-center justify-center p-6 lg:p-12 bg-lum-bg-light">
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="lg:hidden flex justify-center mb-8">
            <img src="/lumora-logo-refined.svg"
              alt="Lumora" className="h-10 w-auto" />
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
